import styled from 'styled-components';

import { EditorStyled } from '@xing-com/crate-articles-article-editor';
import {
  mediaSmallOrTiny,
  mediaConfinedNavlessOnly,
} from '@xing-com/layout-tokens';
import { spaceXL, scale110 } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const ViewerContainer = styled.div`
  flex: 1;
`;

export const HeaderText = styled(BodyCopy)`
  display: flex;
  flex: 1;
  align-self: center;
  max-height: 120px;
  overflow: hidden;
  margin: 0 0 ${spaceXL} 0 !important;
  font-size: ${scale110};

  @media ${mediaSmallOrTiny} {
    padding-right: 0;
  }

  @media ${mediaConfinedNavlessOnly} {
    max-height: 120px;
  }

  @media (min-width: 1113px) {
    max-height: 155px;
    font-size: 32px;
    line-height: 1.2;
  }
`;

export const EditorContent = styled.div`
  ${EditorStyled.EditorStyle}
`;
